<script>
import { QCheckbox, QIcon } from 'quasar'
import { mergeData } from 'vue-functional-data-merge'

export default {
  functional: true,
  props: {
    prependIcon: String,
    clearable: {
      type: Boolean,
      default: true
    },
    valueType: {
      type: String,
      default: 'number'
    },
    trueValue: {
      type: [Number, String],
      default: 1
    },
    falseValue: {
      type: [Number, String],
      default: 0
    }
  },
  render (createElement, { props, data, children }) {
    return createElement(QCheckbox, mergeData({
      props: props,
      scopedSlots: {
        prepend: props.prependIcon ? () => {
          return createElement(QIcon, {
            props: { name: props.prependIcon }
          })
        } : null
      }
    }, data), children)
  }
}
</script>
